import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import LockIcon from '../../../../commonComponents/icons/LockIcon';

const LevelCard = props => {
  const { t, index, levelData } = props;

  const {
    level,
    skillLevel,
    personalPV,
    totalPVWeakLegs,
    recruitGoal,
    recruitGoalLevel,
    recruitGoalOneLeg,
  } = levelData;

  const isLevelComplete = cardIndex => {
    if (cardIndex === 0) {
      return level > 0;
    }
    return false;
  };

  const isStageComplete = stageObject => stageObject?.limitAchieved;

  const daysLeft = () => {
    const endOfWeek = moment().endOf('isoWeek');

    return endOfWeek.diff(moment().startOf('day'), 'days');
  };

  const levelProgress = () => {
    const hoursInWeek = 7 * 24;
    const currentWeekHour = moment().diff(moment().startOf('isoWeek'), 'hours');
    return (currentWeekHour * 100) / hoursInWeek;
  };

  return (
    <div className={`level-card card-${index + 1}`}>
      {isLevelComplete(index) && (
        <div className="cardBookmark">
          <span className="cardBookmarkText">
            {t('report.arcova.levelCompleted')}
            <img
              src="/images/reports/party-hat.svg"
              alt="yay"
              className="partyHat"
            />
          </span>
        </div>
      )}
      <div className="cardHeader">
        {index === 2 && (
          <div className="cardLockContainer">
            <LockIcon width={76} height={96} />
          </div>
        )}
        <span className="levelLabel">
          {t('report.arcova.level')} {level}
        </span>
        <img
          src={skillLevel.icon}
          alt={skillLevel.name}
          className="level-card-image"
        />
        {isLevelComplete(index) && (
          <div className="completedLevelCheck">
            <CheckIcon />
          </div>
        )}
        <span className="levelLabelName">{skillLevel.name}</span>
        {index === 1 && (
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${levelProgress()}%`,
              }}
            >
              {daysLeft()} {t('report.arcova.daysLeft')}
            </div>
          </div>
        )}
      </div>
      <div className="cardTableBody">
        <table className="table" style={{ width: '100%' }}>
          <tbody>
            <tr className="content" key="row-1">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(personalPV) && <CheckIcon color="#3FBC5F" />}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{personalPV?.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-3">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(recruitGoal) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{recruitGoal?.limit}
                  {recruitGoal?.limit > 0 && (
                    <span>
                      {', '}
                      {t('report.mivitana.objectives.atLeastLevel')}
                      {recruitGoalLevel.toString()}
                    </span>
                  )}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-2">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(totalPVWeakLegs) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;{totalPVWeakLegs?.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-4">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {isStageComplete(recruitGoalOneLeg) && (
                    <CheckIcon color="#3FBC5F" />
                  )}
                </div>
                <span className="contentCellText">
                  &gt;=&nbsp;
                  {recruitGoalOneLeg?.limit ?? '0'}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

LevelCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  levelData: PropTypes.shape({
    level: PropTypes.number.isRequired,
    skillLevel: PropTypes.shape({
      icon: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    personalPV: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    totalPVWeakLegs: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    recruitGoal: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
    }).isRequired,
    recruitGoalLevel: PropTypes.number.isRequired,
    recruitGoalOneLeg: PropTypes.number.isRequired,
    SponsorsAtLeastInOneLeg: PropTypes.shape({
      limit: PropTypes.string,
      limitAchieved: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

export default translate(LevelCard);
